import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { CheckoutValidationMessages } from "app/_components/checkout-validation/checkout-validation.messages";
import { CheckoutFormGroup } from "app/_components/checkout/checkout.component";
import { SpecialPartNumber } from "entities/enums";
import { OrderType } from "entities/order-type";
import { getNormalizedCartLineItemVins, VIN_PATTERN } from "helpers/cart-line-item-vins";

/**
 * Validates that all cart line items with cumminsVinRequired === true
 * have a valid VIN entered. Only enforced for orders (not quotes)
 * when the user is NOT a Canada user (i.e., US only).
 */
export const vinRequiredValidator = (): ValidatorFn => {
    return (control: AbstractControl): ValidationErrors | null => {
        const checkoutFormGroup = control.root as FormGroup<CheckoutFormGroup>;
        const cartData = checkoutFormGroup.value?.shippingAndDelivery?.cartData;
        const transactionType = cartData?.transactionType;
        const isCanadaUser = checkoutFormGroup.value?.shippingAndDelivery?.shipTo?.isCanadaUser ?? false;

        // Only validate for orders (not quotes) in US (non-Canada users)
        if (transactionType === OrderType.Quote) {
            return null;
        }

        if (isCanadaUser) {
            return null;
        }

        // Check all line items that require VIN
        const lineItemsRequiringVin = cartData?.lineItems
            ?.filter(x => x.partNumber !== SpecialPartNumber.Freight && x.partNumber !== SpecialPartNumber.Delivery)
            ?.filter(x => x.cumminsVinRequired === true);

        if (!lineItemsRequiringVin || lineItemsRequiringVin.length === 0) {
            return null;
        }

        // Check if any line item with cumminsVinRequired is missing a valid VIN
        const hasInvalidVin = lineItemsRequiringVin.some(lineItem => {
            return getNormalizedCartLineItemVins(lineItem).some(vin => {
                if (!vin || vin.trim() === '') {
                    return true;
                }

                return !VIN_PATTERN.test(vin);
            });
        });

        if (hasInvalidVin) {
            return { "vin.required": CheckoutValidationMessages["vin.required"] };
        }

        return null;
    };
};
